interface ArrowRightProps {
    className?: string;
}

const ArrowRightLine: React.VFC<ArrowRightProps> = ({ className = '' }) => {
    return (
        <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={className}
        >
            <path d="M12.172 6.99992L6.808 1.63592L8.222 0.221924L16 7.99992L8.222 15.7779L6.808 14.3639L12.172 8.99992L0 8.99992L0 6.99992L12.172 6.99992Z" />
        </svg>
    );
};

export default ArrowRightLine;
